import React, { useState } from 'react';
import { Card, CardBody, CardTitle, CardText, CardHeader, CardSubtitle, Row, Col, CardImg } from 'reactstrap';
import './Carousel.css';

const projects = [
  { id: 3, title: 'AI Questionaire Autofill System', subtitle: "Created for DHI Inc.", desc: 'Set up an AI Retreival Augmented Generation system using OpenAI enterprise and Qdrant. The tool automated vendor security questionaires, and was usable through either a cli or a graphical interface. Also created a system to update the database with new information and ignore outdated or incorrect information.' },
  { id: 1, title: 'Kuberneties Cluster', subtitle: "Personal Project", desc: 'Set up a Kuberneties cluster system in a network with an airgap. Used K3s on Debian.' },
  { id: 2, title: 'Brakmir Dungeon Crawler', subtitle: "Academic / Personal Project", desc: 'Made a proceduraly generated dungeon crawler game using Java and Javafx using many common Gang of Four software patterns.', img: "/images/controllerReflect.jpg" },
  { id: 4, title: "MIDI Music Player", desc: "Created a ground up music player that could read and play midi music files on a STM Microelectronics Board using C in STM32CubeIDE.", img: "/images/stmMEBoard.jpg" },
  { id: 5, title: "Nutrikit", desc: "Created a nutrition planning app with React JS and a Python RESTful Flask API. Included an intuitive API which used PostgreSQL and an adaptive and usable UI that worked across platforms."},
  { id: 6, title: "Trello Bored", desc: "An AI tool that automatically updates your trello bored whenever you push changes, complete merges, or make pull requests. Consists of a server api written in python, a VS-Code extension, and a set of Github Actions templates.", img: "https://creativity103.com/collections/Glow/slides/blur.jpg"},
  { id: 7, title: "This Site", desc: "This site was created in React using bootstrap to give an excellent user experience on both mobile and desktop devices."},
  { id: 8, title: "And More!", desc: "This is only a selection of the many projects I have done, feel free to contact me to learn about the others and what I have planned!", img: "https://yavuzceliker.github.io/sample-images/image-44.jpg"}
];

function Carousel() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === projects.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? projects.length - 1 : prevIndex - 1
    );
  };

  return (
    <div style={{padding: "5%"}} className="position-relative py-5">

      <button className="carousel-btn prev" onClick={prevSlide}>&#10094;</button>
      <button className="carousel-btn next" onClick={nextSlide}>&#10095;</button>

      <div className="carousel-window">
        
        <div 
          className="carousel-track"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {projects.map((project) => (
            <div className="carousel-slide" key={project.id}>
              <Row md={project.img ? "2" : "1"} sm="1" xs="1">
              <Col>
                <Card className="text-center">
                  <CardHeader>
                    <CardTitle tag="h3">
                      {project.title}
                    </CardTitle>
                    {(project.subtitle) && <CardSubtitle>{project.subtitle}</CardSubtitle>}
                  </CardHeader>
                  <CardBody>
                    <CardText>
                      {project.desc}
                    </CardText>
                  </CardBody>
                </Card>
              </Col>
              {project.img && <Col><Card><CardBody><CardImg src={project.img}/></CardBody></Card></Col>}
              </Row>
            </div>
          ))}
        </div>
        
      </div>
    </div>
  );
}

export default Carousel;